import BreakWordTypography from 'components/common/BreakWordTypography'

const ModuleTitle = ({ title, isNarrow = false }) => {
  return (
    <BreakWordTypography
      variant="h4"
      fontWeight="fontWeightBold"
      component="h1"
      mb={{ xs: isNarrow ? 4 : 8, lg: isNarrow ? 6 : 8 }}
      color="text.primary"
    >
      {title}
    </BreakWordTypography>
  )
}

export default ModuleTitle
